import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=5cf72faa&scoped=true&"
import script from "./Bulletin.vue?vue&type=script&lang=js&"
export * from "./Bulletin.vue?vue&type=script&lang=js&"
import style0 from "./Bulletin.vue?vue&type=style&index=0&id=5cf72faa&scoped=true&lang=css&"
import style1 from "./Bulletin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf72faa",
  null
  
)

export default component.exports